import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Row from '@totallymoney/ui/components/Row'
import Stack from '@totallymoney/ui/components/Stack'

import { UnscoredLoanProduct } from '@appTypes/LoansApi.interface'

import LoanCategoryTooltip from '@components/LoanCategoryTooltip'
import TableItemImage from '@components/TableItemImage'

interface UnscoredTableItemTitleSectionProps {
    item: UnscoredLoanProduct
    onShowLoanTypeModal: () => void
}

const UnscoredTableItemTitleSection = ({
    item: { lender, loanName, propositionId, imageUrl },
    onShowLoanTypeModal,
}: UnscoredTableItemTitleSectionProps) => (
    <Row space="space20">
        <Box justifySelf={['center', 'unset']} alignSelf="center">
            <TableItemImage cmsImageUrl={imageUrl} name={lender} />
        </Box>

        <Stack space="space10">
            <Heading as="h2" variant="40">
                {lender}
            </Heading>

            <LoanCategoryTooltip
                loanCategory={loanName}
                loanId={propositionId}
                onShowLoanCategoryModal={onShowLoanTypeModal}
            />
        </Stack>
    </Row>
)

export default UnscoredTableItemTitleSection
